import React from "react";
import { Typography, Box } from "@mui/material";
import StatusChip from "../../../common/components/StatusChip";

const StatusHeader = ({ status }) => {
  return (
    <Typography
      variant="h6"
      sx={{
        mt: 4,
        mb: 2,
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "flex-start", sm: "center" },
        gap: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        상태: <StatusChip status={status} />
      </Box>
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
          ml: { xs: 0, sm: 2 },
        }}
      >
        <Box sx={{ display: { xs: "block", sm: "none" } }}>
          과제 열을 길게 누르면 과제 검사 기준이 나옵니다
        </Box>
        <Box sx={{ display: { xs: "none", sm: "block" } }}>
          과제 열을 더블클릭하면 과제 검사 기준이 나옵니다
        </Box>
      </Typography>
    </Typography>
  );
};

export default StatusHeader;
